import { MutableRefObject, useEffect, useRef } from 'react';

import { Present } from '/types';

// Max vertical portion of the screen to fill
const MAX_FILL = 0.95;
// We want a global max scale so that small blocks do
// not get stretched all the way to the max_fill point.
// Aiming for a 100px block to fill 25% of the window height.
const MAX_SCALE = (0.25 * window.innerHeight) / 100;

const adjust = (element: HTMLElement, scale: number): void => {
  // @ts-ignore noImplicitAny
  element.style['max-width'] = `calc(85%/${scale})`;
  // @ts-ignore noImplicitAny
  element.style['transform'] = `scale(${scale})`;
  setTimeout((): void => {
    const ratio = (scale * element.offsetHeight) / window.innerHeight;
    if (ratio > MAX_FILL) {
      adjust(element, scale * 0.97);
    }
  }, 0);
};

const useBlockScaler = (
  blockType: string,
  presentMode: Present,
): MutableRefObject<HTMLElement | undefined> => {
  const blockRef = useRef<HTMLElement>();

  useEffect(() => {
    const element = blockRef?.current;
    if (element && presentMode) {
      adjust(
        element,
        Math.min(window.innerHeight / element.offsetHeight, MAX_SCALE),
      );
    } else if (element && !presentMode) {
      // @ts-ignore noImplicitAny
      element.style['max-width'] = 'unset';
      // @ts-ignore noImplicitAny
      element.style['transform'] = 'none';
    }
  }, [blockRef, blockType, presentMode]);

  return blockRef;
};

export default useBlockScaler;
